import api from '@/api'

const { $academic} = api;

export const { $equivalences, $departments, $subjects } = $academic;